import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { RequireAuth } from '@/components/layout/RequireAuth';
import { EmptyState } from '@/components/ui/empty-state';

/**
 * Engagement list — placeholder. The backend has no `GET /engagements`
 * surface today; this page is wired so the navigation tree resolves but
 * the body explains the gap. Once a list endpoint exists, the page
 * renders the rows here.
 */
export const Route = createFileRoute('/engagements/')({
  component: EngagementsIndexPage,
});

function EngagementsIndexPage() {
  return (
    <RequireAuth>
      <div className="space-y-6">
        <div>
          <Button asChild variant="ghost" size="sm" className="-ml-2 mb-2">
            <Link to="/">
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
              <span>Back to dashboard</span>
            </Link>
          </Button>
          <h1 className="text-2xl font-semibold tracking-tight">Engagements</h1>
        </div>
        <Card>
          <CardHeader>
            <CardTitle>Need an engagement list endpoint</CardTitle>
            <CardDescription>
              The API doesn&apos;t yet expose a per-user engagement feed. Until it does, navigate
              via the dashboard (Clients) or paste an engagement_id directly into the URL.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <EmptyState
              title="Pick a client to find its engagements"
              description="Try /engagements/{engagement_id} once you have one in hand."
            />
          </CardContent>
        </Card>
      </div>
    </RequireAuth>
  );
}
